<template>
  <section class="max-w-screen-xl mx-auto">
    <div
        v-if="error != 0"
        class="fixed inset-x-0 bottom-4 z-50 mx-auto max-w-md"
    >
      <div
          class="flex items-center justify-between gap-x-4 bg-gray-900 px-4 py-3 rounded-lg shadow-lg"
      >
        <p class="text-sm leading-6 text-white">
          <strong class="font-semibold">{{ $t(pageStr + '.fehler') }}</strong>
          <svg
              viewBox="0 0 2 2"
              class="mx-2 inline h-0.5 w-0.5 fill-current"
              aria-hidden="true"
          >
            <circle cx="1" cy="1" r="1"/>
          </svg>
          {{ $t(pageStr + '.session_id_not_found') }}<span aria-hidden="true">&rarr;</span>
        </p>
        <button
            type="button"
            @click="error = 0"
            class="-m-3 flex-none p-3 focus-visible:outline-offset-[-4px]"
        >
          <span class="sr-only">{{ $t(pageStr + '.dismiss') }}</span>
          <svg
              class="h-5 w-5 text-white"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
          >
            <path
                d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z"
            />
          </svg>
        </button>
      </div>
    </div>
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="bg-gradient-to-b from-white to-gray-50 py-12 px-4 sm:px-6 lg:py-16">
      <div class="max-w-3xl mx-auto">
      <div class="text-center">
          <h2
              class="text-3xl tracking-tight font-extrabold text-gray-900 sm:text-4xl"
          >
            {{ $t(pageStr + '.no_active_configurations') }}
          </h2>
          <p class="mt-3 max-w-2xl text-center mx-auto text-xl text-gray-500 sm:mt-4">
            {{ $t(pageStr + '.you_have_no_active_configurations') }} <br/>
            {{ $t(pageStr + '.to_start_a_new_one_select') }}
          </p>
        </div>
        <div class="mt-8 max-w-md mx-auto">
          <div class="bg-white rounded-xl shadow-sm p-4">
            <div class="flex gap-3">
            <div class="flex-grow">
                <input
                    type="text"
                    name="item_number"
                    v-model="itemNumber"
                    @keyup.enter="createSession(itemNumber)"
                    class="block w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
                    :placeholder="$t(pageStr + '.enter_item_number')"
                    aria-describedby="item-number-helper"
                />
              </div>
              <span class="ml-3">
                      <button
                          type="button"
                          @click="createSession(itemNumber)"
                          
                          class="bg-white inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500"
                      >
                        <!-- Heroicon name: solid/plus -->
                        <svg
                            class="-ml-2 mr-1 h-5 w-5 text-gray-400"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                        >
                          <path
                              fill-rule="evenodd"
                              d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                              clip-rule="evenodd"
                          />
                        </svg>
                        <span>{{ $t(pageStr + '.open') }}</span>
                      </button>
                    </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import {defineComponent, onMounted, ref} from "vue";
import {Sessions} from "@/assets/ts/sessions";
import {useStore} from "vuex";
import router from "@/router";
import {useRoute} from "vue-router";

export default defineComponent({
  name: "ConfInit",
  components: {},
  setup() {
    const store = useStore();
    const route = useRoute();
    const sessionId = ref("");
    const error = ref(0);
    const itemNumber = ref("");
    const initItem = ref("");
    const pageStr = "pages.init"

    const createSession = (newItemNumber = "RU-1114-1", filters: { [key: string]: string } = {}) => {
      if (newItemNumber === "") {
        error.value = 2;
      } else {
        store.commit("loading/actionStarted");

        const sessionsObj: Sessions = new Sessions();

        sessionsObj.create(newItemNumber, filters).then((newSessionId: any) => {
          store.commit("loading/actionFinished");
          if (newSessionId !== "") {
            router.push({
              name: "ConfigurationOverview",
              params: {
                sessionId: newSessionId
              },
            });
          }
        });
      }
    };


    const loadSession = () => {
      store.commit("loading/actionStarted");

      const sessionsObj: Sessions = new Sessions();

      sessionsObj.get(sessionId.value).then((sessionData: any) => {
        store.commit("loading/actionFinished");
        if (typeof sessionData.error != "undefined") {
          error.value = sessionData.error;
        } else {
          store.commit("session/setFull", sessionData);
          router.push({
            name: "ConfigurationOverview",
            params: {
              sessionId: sessionId.value,
            },
          });
        }
      });
    };

    onMounted(() => {
      if (route.query.add) {
        const uri_parts = (route.query.add as string).split("/");

        const filterPairs = uri_parts.slice(1);

        const activeFilters: { [key: string]: string } = {
          "catalog": filterPairs[0]
        }
        for (let i = 1; i < filterPairs.length; i += 2) {
          if (filterPairs[i] && filterPairs[i + 1]) {
            activeFilters[filterPairs[i]] = filterPairs[i + 1];
          }
        }

        createSession(uri_parts[0], activeFilters)
      }
    });

    if (window.__CONFIGURATOR_PROPS__) {
      if (window.__CONFIGURATOR_PROPS__.initialItem != '') {
        createSession(window.__CONFIGURATOR_PROPS__.initialItem)
        window.__CONFIGURATOR_PROPS__.initialItem = ""
      }
    }


    return {createSession, loadSession, sessionId, error, itemNumber, initItem, pageStr};
  },
});
</script>

<style></style>
